import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import navTracking from 'root/utils/tracking/GA4/navigation/navTracking';

class TabList {
    #tabList: HTMLElement;
    #tabs: NodeListOf<HTMLElement>;
    #tabPanels: NodeListOf<HTMLElement>;
    #focusedTabIndex: number;

    constructor(el: HTMLElement) {
        this.#tabList = el;
        this.#tabs = this.#tabList.querySelectorAll('[role="tab"]');
        this.#focusedTabIndex = 0; // keep track of which tab button should get focus, even when focus is elsewhere
        this.#tabPanels = document.querySelectorAll('[role="tabpanel"]');
    }

    #changeTabIndexValues() {
        for (const tab of this.#tabs) {
            tab.setAttribute(
                'tabindex',
                `${tab === this.#tabs[this.#focusedTabIndex] ? '0' : '-1'}`
            );
        }
    }
    addListeners() {
        for (const tab of this.#tabs) {
            tab.addEventListener('click', ({ currentTarget }) => {
                if (tab.getAttribute('aria-selected') === 'false') {
                    // @ts-ignore
                    gtm.tabClickForPanelChange(tab.innerText.toLowerCase()).sendEvent(
                        'tabs'
                    );
                    const GTMObject = navTracking(currentTarget as HTMLElement);
                    GTMObject && GoogleTagManager.sendEvent(GTMObject);
                }

                const targetPanel =
                    currentTarget instanceof Element
                        ? document.querySelector(
                              `#${currentTarget.getAttribute('aria-controls')}`
                          )
                        : null;

                this.#tabs.forEach((tab, index) => {
                    tab.setAttribute('aria-selected', `${tab === currentTarget}`);
                    if (tab === currentTarget) {
                        this.#focusedTabIndex = index;
                    }
                });
                this.#changeTabIndexValues();

                for (const panel of this.#tabPanels) {
                    if (panel === targetPanel) {
                        panel.removeAttribute('hidden');
                    } else {
                        panel.setAttribute('hidden', '');
                    }
                }
            });
        }
        this.#tabList.addEventListener('keydown', event => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
                event.preventDefault();
                if (event.key === 'ArrowRight') {
                    this.#focusedTabIndex++;
                    if (this.#focusedTabIndex >= this.#tabs.length) {
                        this.#focusedTabIndex = 0;
                    }
                } else if (event.key === 'ArrowLeft') {
                    this.#focusedTabIndex--;
                    if (this.#focusedTabIndex < 0) {
                        this.#focusedTabIndex = this.#tabs.length - 1;
                    }
                }
                this.#changeTabIndexValues();
                this.#tabs[this.#focusedTabIndex].focus();
                this.#tabs[this.#focusedTabIndex].click();
            }
        });
    }
}
export default function tablist(tabLists: HTMLElement[]) {
    tabLists.forEach(tabList => {
        const tl = new TabList(tabList);
        tl.addListeners();
    });
}
